import { Accordion, AccordionDetails, AccordionSummary, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { ReactComponent as ArrowIcon } from 'assets/icons/faq-arrow.svg';

interface Props {
    question: string;
    answer: string;
    sx?: SxProps;
}

export const FaqItem: FC<Props> = ({ question, answer, sx }) => {
    return (
        <Accordion
            sx={{
                backgroundColor: 'background.white',
                borderRadius: '8px',
                boxShadow: 'none',
                mt: '0 !important',
                '&::before': {
                    display: 'none',
                },
                ...sx,
            }}
        >
            <AccordionSummary
                expandIcon={<ArrowIcon />}
                sx={{
                    border: 'none',
                    borderRadius: '.5rem',
                    padding: '26px 8px 26px 18px',
                    gap: '1.5rem',
                    '& .MuiAccordionSummary-content': {
                        margin: '0 !important',
                    },
                }}
            >
                <Typography variant="body4Medium" sx={{ color: 'background.default' }}>
                    {question}
                </Typography>
            </AccordionSummary>
            <AccordionDetails
                sx={{
                    padding: '8px 12px',
                }}
            >
                <Typography variant="captionLight" sx={{ color: 'text.lightGray', fontSize: '16px' }}>
                    {answer}
                </Typography>
            </AccordionDetails>
        </Accordion>
    );
};
